import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
import { companyService } from '../../services/companyService';
import { Company, formatCnpj } from '../../types/company';
import { toggleCompanyId } from './companyFilterUtils';

interface CompanyFilterPillsProps {
  /** Empresas selecionadas; vazio = todas. */
  selected: number[];
  onChange: (ids: number[]) => void;
}

/**
 * Filtro de empresa emissora do Relatório de Vendas: uma, várias ou todas.
 * "Todas" é o estado sem seleção (o backend não filtra empresa).
 */
export const CompanyFilterPills: React.FC<CompanyFilterPillsProps> = ({ selected, onChange }) => {
  const [companies, setCompanies] = useState<Company[]>([]);

  useEffect(() => {
    companyService.getCompanies().then(setCompanies).catch(() => {});
  }, []);

  const pillCls = (active: boolean) =>
    `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-all cursor-pointer select-none ${
      active
        ? 'bg-emerald-50 border-emerald-300 text-emerald-700'
        : 'bg-white border-slate-200 text-slate-500 hover:border-slate-300'
    }`;

  const allSelected = selected.length === 0;

  return (
    <div>
      <label className="block text-xs font-medium text-slate-600 mb-2 uppercase tracking-wider">Empresa</label>
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={() => onChange([])} className={pillCls(allSelected)}>
          {allSelected && <Check size={12} />}
          Todas
        </button>
        {companies.map(c => {
          const isSelected = selected.includes(c.company_id);
          return (
            <button
              key={c.company_id}
              type="button"
              title={formatCnpj(c.document)}
              onClick={() => onChange(toggleCompanyId(selected, c.company_id, companies.map(x => x.company_id)))}
              className={pillCls(isSelected)}
            >
              {isSelected && <Check size={12} />}
              {c.name}
            </button>
          );
        })}
      </div>
      {!allSelected && (
        <p className="text-xs text-slate-400 mt-1">
          {selected.length} empresa{selected.length !== 1 ? 's' : ''} selecionada{selected.length !== 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};
